import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import PhysVisUtil from "@/PhysVisUtil";
import CameraEngineChaseCopter from './CameraEngineChaseCopter';
import CameraEngineOrbital from './CameraEngineOrbital';
import CameraEnginePlayerPlace from './CameraEnginePlayerPlace';
import alea from 'alea';
import {createNoise2D} from 'simplex-noise';
import { Water } from 'three/examples/jsm/objects/Water';
import Car from './Car';
import Stats from 'three/examples/jsm/libs/stats.module'
import Grass from './Grass';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import Bird from './Bird';
import Connection from "./Connection";

import SceneView from "@/components/SceneView.vue";
import StartFinishSign from './StartFinishSign';

import ControlPointSign from './ControlPointSign';


class GameSceneRace {

//	MAP_SEED = 'bebebe';
//	MAP_SEED = 'artem';
//	MAP_SEED = 'чтобы все';

	mapSeed: string;

	sceneRootObject: THREE.Object3D = null!;
	
	directionalLight: THREE.DirectionalLight = null!;

	car: Car = null!;

	physVisUtil: PhysVisUtil;

	worldCannon: CANNON.World = null!;
	
	canvas: any;
	
	groundMaterial: any;
	roadMaterial: any;
	


	cameraEngineChaseCopter: any = null!;
	cameraEngineOrbital: any = null!;
	cameraEnginePlayerPlace: any = null!
	
	camera: THREE.PerspectiveCamera = null!;  // камера из CameraEngine

	renderer: THREE.WebGLRenderer;
	scene: THREE.Scene;

	cameraMode = "orbital";

	stats: Stats;

	noise2D;

	TERRAIN_PHYS_SQUARE_SIZE = 24; // размер физического квадрата, м

	TERRAIN_PHYS_RESOLUTION = 24; // сколько метров между вершинами - физика

	ROAD_PHYS_RESOLUTION = 4; // сколько метров между строками дороги - физика

///	TERRAIN_GRAPH_SQUARE_SIZE = 168; // размер графического квадрата, м
//	TERRAIN_GRAPH_SQUARE_SIZE = 96; // размер графического квадрата, м
	TERRAIN_GRAPH_SQUARE_SIZE = 72; // размер графического квадрата, м
	
	TERRAIN_GRAPH_RESOLUTION = 24; // сколько метров между вершинами - графика
	
	TERRAIN_GRAPH_RESOLUTION_PLAYER_PLACE = 4; // сколько метров между вершинами - графика в режиме "Владение игрока"

//	TERRAIN_NUM_GRAPH_LAYERS = 9;
	TERRAIN_NUM_GRAPH_LAYERS = 7;
//	TERRAIN_NUM_GRAPH_LAYERS = 5;

	TERRAIN_NUM_GRAPH_LAYERS_PLAYER_PLACE = 2;


    physSquares = new Map<string, CANNON.Body>();  // физические квадраты
    physSquaresVisual = new Map<string, THREE.Object3D>();  // физические квадраты, отладочное отображение

    physStrings = new Map<string, CANNON.Body>();  // физические строки дорожной насыпи
    physStringsVisual = new Map<string, THREE.Object3D>();  // физические квадраты, отладочное отображение

     
    graphSquares = new Map<string, THREE.Object3D>();  // графические квадраты

	physSquaresList: string[] = [];
	graphSquaresList: string[] = [];

	physStringsList: string[] = [];
	
	materialGround: any = null!;
	materialRock: any = null!;
	materialRoad: any = null;
	
	water: any = null!;

///	WATER_HEIGHT = -130;
	WATER_HEIGHT = -40;

///	MAX_HEIGHT_ROCK = 100;
//	MAX_HEIGHT_ROCK = 20;
	MAX_HEIGHT_ROCK = 30;
///	MAX_HEIGHT_GROUND = 5;
	MAX_HEIGHT_GROUND = 20;

	ROAD_HALF_WIDTH = 6;
	ROAD_HALF_WIDTH_GROUND = 15;	// отодвигаем холмы от дороги
	ROAD_HALF_WIDTH_ROCK = 20;	// отодвигаем горы от дороги
	
	ROAD_SLOPE_WIDTH_GROUND = 120 * 2; // ширина откоса земли вдоль дороги, м
	ROAD_SLOPE_WIDTH_ROCK = 120 * 2 * 4; // ширина откоса гор вдоль дороги, м

	ROAD_AMPLITUDE_X = 150;  // изгибы дороги влево-вправо	
//	ROAD_AMPLITUDE_Y = 200;	 // изгибы дороги вверх-вниз
//	ROAD_AMPLITUDE_Y = 205;	 // изгибы дороги вверх-вниз
	ROAD_AMPLITUDE_Y = 60;	 // изгибы дороги вверх-вниз
//	ROAD_AMPLITUDE_Y = 120;	 // изгибы дороги вверх-вниз
//	ROAD_AMPLITUDE_Y = 0;	 // изгибы дороги вверх-вниз
	
	ROAD_BANK_HEIGHT = 0.3; // высота насыпи дороги, м
	ROAD_BANK_WIDTH = 1.5; // ширина откоса насыпи дороги, м

	terrainPhysicsShow = false;
	
	visibleObjectPhysSquares: THREE.Object3D;
	visibleObjectPhysStrings: THREE.Object3D;
	
	grassEnabled = true;
	grassTechnique = 'alphaTest';
//	grassTechnique = 'depthWrite';

	grass: Grass = null!;
	
	grassLoaded = false;

	prng: any;
	prngGameInstance: any;
	
	prevTime = 0;
	
	flatRoad: boolean;
	straightRoad: boolean;
	
	startTime: number;

	shadowCameraHelper: THREE.CameraHelper = null!;

	lightHelper: THREE.DirectionalLightHelper = null!;
	
	isPlayerPlace: boolean;
	
	birds: Bird[] = [];

    servers = [
	{name: 'отладочный - балансер : node0/node1', address: "wss://godsofroads.online:4887", storagePrefix: "_gor_dev1"},
	{name: 'отладочный - node0', address: "wss://godsofroads.online:4888", storagePrefix: "_gor_dev1"},
	{name: 'отладочный - node1', address: "wss://godsofroads.online:4889", storagePrefix: "_gor_dev1"},
	{name: 'боевой - балансер : node0/node1', address: "wss://godsofroads.ru:4867", storagePrefix: "_gor_prod1"},
	{name: 'боевой - node0', address: "wss://godsofroads.ru:4868", storagePrefix: "_gor_prod1"},
	{name: 'боевой - node1', address: "wss://godsofroads.ru:4869", storagePrefix: "_gor_prod1"}
	];
	
	connection: Connection = null!;
	
	showCompassCont: any;
	
	gameMode: string;
	
	signStart: StartFinishSign = null!;
	signFinish: StartFinishSign = null!;
	
	trophyControlPoints: ControlPointSign[] = [];
	
	currentTrophyPointNumber = 0;

	///////////////////////////////////////////////////////////////////////////////////
	constructor(mapSeed: string, gameMode: string, scene: THREE.Scene, canvas: any, renderer: THREE.WebGLRenderer, 
		flatRoad: boolean, straightRoad: boolean, isPlayerPlace: boolean, showCompassCont: any) {

		this.mapSeed = mapSeed;

		const p = document.getElementById("gameSpecs");
		if (p != null) {
			p.style.display = 'block';
		} 
		
		this.gameMode = gameMode;
		
		//AppCompass
		this.showCompassCont = showCompassCont;
		
		console.log("GameLevel.constructor");
		
		this.isPlayerPlace = isPlayerPlace;
		
		this.startTime = Date.now();
		
		this.flatRoad = straightRoad;
		this.straightRoad = straightRoad;
		
		this.visibleObjectPhysSquares = new THREE.Object3D();
		this.visibleObjectPhysStrings = new THREE.Object3D();

		this.renderer = renderer;
		this.scene = scene;
		
		this.canvas = canvas;
		
		
		this.physVisUtil = new PhysVisUtil();

		this.groundMaterial = new CANNON.Material('ground');
		this.roadMaterial = new CANNON.Material('road');

		// присоединяем уровень к сцене, генерируем его
		this.worldCannon = new CANNON.World();
		this.worldCannon.gravity.set(0, -9.8, 0)
///			this.worldCannon.gravity.set(0, -1, 0)
//        	this.world.gravity.set(0, -1, 0.5)

		this.worldCannon.broadphase = new CANNON.SAPBroadphase(this.worldCannon);
		this.worldCannon.defaultContactMaterial.friction = 0;


		

		this.sceneRootObject = new THREE.Object3D();
		scene.add(this.sceneRootObject);


		this.prng = alea(this.mapSeed + this.isPlayerPlace ? Date.now() : "");
//		console.log("prng = " + this.prng);
		
		this.noise2D = createNoise2D(this.prng);
		
//		console.log("noises created");




		this.createWater();

//		const initZ = 450;
		const initZ = 0;
//		const initZ = -4600;
		
		// ставим машину точно на дорогу
		/*
		const pz = (initZ / 4 + 128) * 2 / 256;
		const initX = this.straightRoad ? 0 : this.ROAD_AMPLITUDE_X * this.noise2D(pz / 4, 0);  // метры
		const initY = 30;
///		const initY = 50;
		*/
		let road = this.getRoad(initZ);
		const initX = (road.roadLeft + road.roadRight) / 2 + this.ROAD_HALF_WIDTH / 2;  // на центр правой полосы
//		const initX = road.roadLeft;
		const initY = road.heightM + 1; 

		this.car = new Car(this.sceneRootObject, this.worldCannon, this.groundMaterial, this.roadMaterial,  
							initX, initY, initZ, this);

        this.worldCannon.addEventListener('postStep', () => {

            // Gravity towards (0,0,0)
            this.worldCannon.bodies.forEach((b) => {
                const v = new CANNON.Vec3()
                //v.set(-b.position.x, -b.position.y, -b.position.z).normalize()  // сферическая гравитация, для заездов на астероиде
                v.set(0, -1, 0)
//                v.scale(9.8 * 3, b.force)
//                v.scale(9.8 * 1000, b.force)
                v.scale(9.8 * 1, b.force)
//                v.scale(9.8 * 0, b.force)  // для отладки уменьшаю гравитацию
                b.applyLocalForce(v)
////                b.force.y += b.mass //cancel out world gravity
// ^- отсюда и получался взлёт
            })
        })



		//this.createVehicle(this.sceneRootObject);

		const position = this.car.getPhysBodyPosition();
		const quaternion = this.car.getPhysBodyQuaternion();
		this.cameraEngineChaseCopter = new CameraEngineChaseCopter(scene, position, quaternion);

		this.cameraEngineOrbital = new CameraEngineOrbital(scene, this.canvas.value);  // т.к. value - это HTML canvas, принимающий события, а this.canvas - webGl-обвязка  

		this.cameraEnginePlayerPlace = new CameraEnginePlayerPlace(scene, this.canvas.value);

		
//		this.cameraMode = "chaseCopter";
//		this.cameraMode = "orbital";

		if (!this.isPlayerPlace) {
			this.changeCameraMode("chaseCopter");	// по умолчанию пусть будет вид с тыла машины
		} else {
			this.changeCameraMode("playerPlace");
		} 
		


		
		this.addLights(scene);

		this.addControls();
		
		// skybox
		const loader = new THREE.CubeTextureLoader();
		loader.setPath('images/skyboxes/interstellar/');

		const textureCube = loader.load([
			'xpos.png', 'xneg.png',
			'ypos.png', 'yneg.png',
			'zpos.png', 'zneg.png'
		]);

		scene.background = textureCube;
		
		
		
		const color = "#D0FFE0";  // туман - дальние горы делаем рериховского цвета
///		const color = "#B0E0C0";  // лучше пусть зеленоватый, из-за выбранного скайбокса
//		scene.fog = new THREE.Fog(color, 750, 1500);
		scene.fog = new THREE.Fog(color, 400, 1000);
//		scene.fog = new THREE.Fog(color, 300, 700);
		
		this.stats = new Stats();
		document.body.appendChild(this.stats.dom);
		
		// материалы
		const textureLoader = new THREE.TextureLoader();
		
		//let texture = textureLoader.load('images/terrain_plain.png');
//		let texture = textureLoader.load('images/grass-stone-mountain_base_1k.jpg');

//		let texture = textureLoader.load('images/rocks-land_base_1k.jpg');
//		const textureNormal = textureLoader.load('images/rocks-land_normal_1k.jpg');

//		let texture = textureLoader.load('images/grass-stone-mountain_base_1k.jpg');
//		let textureNormal = textureLoader.load('images/grass-stone-mountain_normal_1k.jpg');

		let texture = textureLoader.load('images/grass-gravel_base_1k.jpg');
		let textureNormal = textureLoader.load('images/grass-gravel_normal_1k.jpg');
		
		///const textureDisp = textureLoader.load('images/rocks-land_disp_1k.jpg');
//		this.materialGround = new THREE.MeshLambertMaterial({ map: texture });
		this.materialGround = new THREE.MeshStandardMaterial({ map: texture, normalMap: textureNormal/*, displacementMap: textureDisp*/ });
//		this.materialGround = new THREE.MeshPhongMaterial({ map: texture });

//		texture = textureLoader.load('images/dirty-rock-2048x2048.jpg');

//		texture = textureLoader.load('images/rocks-land_base_1k.jpg');
//		textureNormal = textureLoader.load('images/rocks-land_normal_1k.jpg');
		texture = textureLoader.load('images/rocks-land_base_1k.jpg');
		textureNormal = textureLoader.load('images/rocks-land_normal_1k.jpg');
		
		this.materialRock = new THREE.MeshLambertMaterial({ map: texture, normalMap: textureNormal });
//this.materialRock = new THREE.MeshBasicMaterial({ color: 0x80ff80, wireframe: true });
		
		
		//const texture = loader.load('images/Seamless-Road-Texture1.jpg');
		//texture = textureLoader.load('images/RoadsDirt0082_2_500.jpg');
		texture = textureLoader.load('images/RoadsDirt0070_1_350.jpg');
		//texture = textureLoader.load('images/RoadsDirt0070_1_350_square.jpg');
		this.materialRoad = new THREE.MeshLambertMaterial({ map: texture });
		
		if (this.grassEnabled) {
			this.grass = new Grass(this.grassTechnique, this);//, this.grassLoadedCallback);
		}
		
//		const el = document.getElementById("canvas");
//		if (el != null) {
//			el.focus();
//		}


		if (this.isPlayerPlace) {
			// приделываем к горе обрамление входа (ворота)
			
			const loader = new GLTFLoader();
			
			loader.load('models/temple_entrance.glb', (gltf) => {
				
				gltf.scene.rotateY(Math.PI / 2);
				
				gltf.scene.scale.x = 17;
				gltf.scene.scale.y = 17;
				gltf.scene.scale.z = 30;
				
				gltf.scene.position.x = 27;
				gltf.scene.position.y = 0;
				
				scene.add(gltf.scene);
			});

			loader.load('models/vault_box_open_example.glb', (gltf) => {
				
				gltf.scene.rotateZ(Math.PI / 2);
				
				gltf.scene.scale.x = 0.5;
				gltf.scene.scale.y = 0.5;
				gltf.scene.scale.z = 0.5;
				
				gltf.scene.position.x = 35;
				gltf.scene.position.z = -8;
				
				scene.add(gltf.scene);
			});
			
		}

		for (let i = 0; i < 5; i++) {
			this.birds.push(new Bird(this.sceneRootObject, this));
		}

		let z;
		
		this.prngGameInstance = alea(this.mapSeed + Date.now());  // у всех игроков этот генератор должен идти от одного сида, но для каждой новой игры он случаен
		// - но пока игра не сетевая, создаём генератор просто здесь 

		const pointColor = 0xFFFFFFFF;
		let controlPoint;

		let pStatus;
		
		const pSpecsName = document.getElementById("gameSpecsName");

		const pSpecsControlPointDistanceCaption = document.getElementById("gameSpecsControlPointDistanceCaption");

		switch(gameMode) {
			case 'drag':
				// создаём стартовый и финишный знаки (сразу, т.к. это демка; но вообще надо создавать/перемещать/уничтожать динамически)
				this.signStart = new StartFinishSign(this);
				z = -10;
				road = this.getRoad(z);
				this.signStart.setStartPosition((road.roadLeft + road.roadRight) / 2, road.heightM, z);
				this.signStart.screenObject.rotateY(Math.PI / 2);

				this.signFinish = new StartFinishSign(this);
				z = -800;
				road = this.getRoad(z);
				this.signFinish.setStartPosition((road.roadLeft + road.roadRight) / 2, road.heightM, z);
				this.signFinish.screenObject.rotateY(-Math.PI / 2);
				
				pStatus = document.getElementById("gameSpecsStatus");
				if (pStatus != null) {
					pStatus.innerHTML = "ещё не доехал до финиша";
				}
				if (pSpecsName != null) {
					pSpecsName.innerHTML = "Дрэг";
				}
				if (pSpecsControlPointDistanceCaption != null) {
					pSpecsControlPointDistanceCaption.style.display = "none";
				}
				break;
			
			case 'rally':
				// создаём стартовый и финишный знаки (сразу, т.к. это демка; но вообще надо создавать/перемещать/уничтожать динамически)
				this.signStart = new StartFinishSign(this);
				z = -10;
				road = this.getRoad(z);
				this.signStart.setStartPosition((road.roadLeft + road.roadRight) / 2, road.heightM, z);
				this.signStart.screenObject.rotateY(Math.PI / 2);

				this.signFinish = new StartFinishSign(this);
				z = -2000;
				road = this.getRoad(z);
				this.signFinish.setStartPosition((road.roadLeft + road.roadRight) / 2, road.heightM, z);
				this.signFinish.screenObject.rotateY(-Math.PI / 2);
				
				pStatus = document.getElementById("gameSpecsStatus");
				if (pStatus != null) {
					pStatus.innerHTML = "ещё не доехал до финиша";
				}
				if (pSpecsName != null) {
					pSpecsName.innerHTML = "Ралли";
				}
				if (pSpecsControlPointDistanceCaption != null) {
					pSpecsControlPointDistanceCaption.style.display = "none";
				}
				break;
			
			case 'trophy':
				// только старт, финиша не будет 
				this.signStart = new StartFinishSign(this);
				z = -10;
				road = this.getRoad(z);
				this.signStart.setStartPosition((road.roadLeft + road.roadRight) / 2, road.heightM, z);
				this.signStart.screenObject.rotateY(Math.PI / 2);

				if (pSpecsName != null) {
					pSpecsName.innerHTML = "Трофи";
				}
				
				// контрольные точки
				
//				for (let i = 0; i < 8; i++) {
				for (let i = 0; i < 3; i++) {  // в демке лучше не слишком много делать
					/*
					switch(i) {
						case 0: 
							pointColor = 0x000000FF;
							break;
						case 1: 
							pointColor = 0xFF0000FF;
							break;
						case 2: 
							pointColor = 0x00FF00FF;
							break;
						case 3: 
							pointColor = 0x0000FFFF;
							break;
						case 4: 
							pointColor = 0xFFFF00FF;
							break;
						case 5: 
							pointColor = 0x00FFFFFF;
							break;
						case 6: 
							pointColor = 0xFF00FFFF;
							break;
						case 7: 
							pointColor = 0xFFFFFFFF;
							break;
					} 
					*/
					// - пусть лучше пройденная (по порядку, конечно) для меня отображается другим цветом
					
					controlPoint = new ControlPointSign(this, pointColor, i);
					
					// ищем место под точку
					// - точка должна быть на земле
					// - точка должна быть не слишком далеко и не слишком близко от предыдущей
					
					let prevX;
					let prevZ;
						
					if (i == 0) {
						// идём от старта
						prevX = this.signStart.startPosition.x;  
						prevZ = this.signStart.startPosition.z;  
						
					} else {
						// идём от предыдущей точки
						prevX = this.trophyControlPoints[i - 1].startPosition.x;
						prevZ = this.trophyControlPoints[i - 1].startPosition.z;
					}
					
					let fnd = false;
					while (!fnd) {
					
						const tryX = prevX + this.prngGameInstance() * 150; 
						const tryZ = prevZ + this.prngGameInstance() * 150; 
						
						const obj = this.getTerrainPoint(tryX, tryZ);
						if (obj.ground > obj.rock) {  // кусты растим только на земле, на скалах не будем
						
							fnd = true;
							
							controlPoint.setStartPosition(tryX, obj.ground + 2, tryZ);
							
							this.trophyControlPoints.push(controlPoint);
							
						}
						
						
					}
					
					
				}
				break;
			
		}


		this.connection = new Connection(this, this.servers[0].address); 

	}
	///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	changeCameraMode(cameraMode: string) {
		
		if (cameraMode == "next") {
			switch(this.cameraMode) {
				case "chaseCopter":
				case "playerPlace":
					cameraMode = "orbital";
					break;
				
				case "orbital":
					if (this.isPlayerPlace) {
						cameraMode = "playerPlace";
					} else {
						cameraMode = "chaseCopter";
					}
					break;
					
			}
			
		}
		
		
		this.cameraMode = cameraMode;
		
		switch(cameraMode) {
			case "chaseCopter":
				this.camera = this.cameraEngineChaseCopter.getCamera();
				break;
				
			case "orbital":
				this.camera = this.cameraEngineOrbital.getCamera();
				break;
				
			case "playerPlace":
				this.camera = this.cameraEnginePlayerPlace.getCamera();
				break;
					
		}
		/*
		if (this.cameraMode == "chaseCopter") {
			this.cameraMode = "orbital";
			
			this.camera = this.cameraEngineOrbital.getCamera();
			
		} else {
			this.cameraMode = "chaseCopter";

			this.camera = this.cameraEngineChaseCopter.getCamera();
		}
		*/
	}
	///////////////////////////////////////////////////////////////////////////////////
	changeCarShowMode() {
		if (this.car != null) {
			this.car.changeShowMode();
		}
	}
	///////////////////////////////////////////////////////////////////////////////////
	changeTerrainShowMode() {
		// включаем/выключаем отображение физических квадратов поверхности и физических строк дорожной насыпи
		this.terrainPhysicsShow = !this.terrainPhysicsShow;
		
		if (this.terrainPhysicsShow) {
			this.scene.add(this.visibleObjectPhysSquares);
			this.scene.add(this.visibleObjectPhysStrings);
		} else {
			this.scene.remove(this.visibleObjectPhysSquares);
			this.scene.remove(this.visibleObjectPhysStrings);
		}
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	createWater() {
		// вода
		const waterGeometry = new THREE.PlaneGeometry(1024, 1024);  // размер фиксированный, а координаты X, Z двигаем вместе с машиной
		this.water = new Water(waterGeometry, {
			textureWidth: 512,
			textureHeight: 512,
			waterNormals: new THREE.TextureLoader().load("images/waternormals.jpg",  texture => {
			texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
			}),
			sunDirection: new THREE.Vector3(),
			sunColor: 0xffffff,
			waterColor: 0x0072ff,
			distortionScale: 4,
			fog: this.scene.fog !== undefined
		});
		this.water.rotation.x = -Math.PI / 2;
		this.water.position.y = this.WATER_HEIGHT;
		this.scene.add(this.water);

	}
	///////////////////////////////////////////////////////////////////////////////////
	/*
	createTrimesh(geometry: THREE.BufferGeometry): CANNON.Trimesh {
        const vertices = geometry.clone().toNonIndexed().attributes.position.array as unknown as number[]
        const indices = Object.keys(vertices).map(Number)
        return new CANNON.Trimesh(vertices, indices)
    }	
    */
    ///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	addLights(scene: THREE.Scene) {

		const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
		scene.add(ambientLight);

		this.directionalLight = new THREE.DirectionalLight(0xffffff, 0.75);
//		this.directionalLight.position.set(1, 0.2, 0);
///		this.directionalLight.position.set(1, 0.2, 0);
//		this.directionalLight.position.set(1000, 250, 0);
		this.directionalLight.position.set(-1000, 500, 0);
		this.directionalLight.target.position.set(1000, -500, 0);

		this.directionalLight.castShadow = true;		
//		this.directionalLight.shadow.bias = -0.0001;
		this.directionalLight.shadow.mapSize.width = 2048;
		this.directionalLight.shadow.mapSize.height = 2048;
		
//		this.directionalLight.shadow.camera.near = 0.5
		//this.directionalLight.shadow.camera.far = 100
		
///		const SHADOW_HALF_WIDTH = 50;
		const SHADOW_HALF_WIDTH = 75;
		this.directionalLight.shadow.camera.top = SHADOW_HALF_WIDTH;
		this.directionalLight.shadow.camera.bottom = -SHADOW_HALF_WIDTH;
		this.directionalLight.shadow.camera.left = -SHADOW_HALF_WIDTH;
		this.directionalLight.shadow.camera.right = SHADOW_HALF_WIDTH;
		this.directionalLight.shadow.camera.near = 1;
		this.directionalLight.shadow.camera.far = 3000;
				
		scene.add(this.directionalLight);
		
		
		this.shadowCameraHelper = new THREE.CameraHelper(this.directionalLight.shadow.camera);
///		scene.add(this.shadowCameraHelper);

		this.lightHelper = new THREE.DirectionalLightHelper(this.directionalLight);
///		scene.add(this.lightHelper);
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	addControls() {
		// управление клавиатурой
		// Keybindings
		// Add force on keydown
		document.addEventListener('keydown', (event: any) => {
			
//			console.log('keydown, event = ' + JSON.stringify(event));
			
        setTimeout(() => {
			
			console.log('keydown, event.key = ' + event.key);
			
			
			switch (event.key) {
				case ' ':
					this.car.control("s+");
					break;
				case 'w':
				case 'ArrowUp':
					this.car.control("u+");
					break;

				case 's':
				case 'ArrowDown':
					this.car.control("d+");
					break;

				case 'a':
				case 'ArrowLeft':
					this.car.control("l+");
					break;

				case 'd':
				case 'ArrowRight':
					this.car.control("r+");
					break;
			}
        }, 200)
			
			
			
			
			
        })

        // Reset force on keyup
		document.addEventListener('keyup', (event: any) => {
			
			console.log('keyup, event = ' + JSON.stringify(event));

        setTimeout(() => {

			console.log('keyup, event.key = ' + event.key);
			
			switch (event.key) {
				case ' ':
					this.car.control("s-");
					break;
				case 'w':
				case 'ArrowUp':
					this.car.control("u-");
					break;

				case 's':
				case 'ArrowDown':
					this.car.control("d-");
					break;

				case 'a':
				case 'ArrowLeft':
					this.car.control("l-");
					break;

				case 'd':
				case 'ArrowRight':
					this.car.control("r-");
					break;
			}
        }, 200)
		})
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	animate() {
		
		if (this.grassEnabled && !this.grassLoaded) {
			return;
		}
		
		if (this.grass != null) { // передаём время шейдеру анимации травы
			const time = Date.now() - this.startTime;
			this.grass.getSettings().time = time / 1000;	
			this.prevTime = time;		
		}		
		
		if (this.birds != null) {
			for (let i = 0; i < this.birds.length; i++) {
				this.birds[i].animate();
			}
		}
		
		// компас
		if (this.showCompassCont != null) {
			this.showCompassCont.showCompass = true;
//			this.showCompassCont = true;
		}
		
		let pC: any = document.getElementById("compass");
		if (pC != null) {
			//console.log("compass = " + JSON.stringify(pC));
			pC.style.display = "block";
			
			pC = document.getElementsByClassName("compass__arrow");
			if (pC != null) {
				
//console.log("pC[0] = " + JSON.stringify(pC[0]));
				
				const quaternion = this.car.frameBody.quaternion;  
				
				const euler:CANNON.Vec3 = new CANNON.Vec3();
				quaternion.toEuler(euler);
				
				
//				pC[0].setAttribute("transform", "rotate(" + euler.y + "rad)");
				pC[0].style.transform = "rotate(" + euler.y + "rad)";
			}
		}
		
		
		
		
		
		
		
		
		// определяем клеточные координаты автомобиля игрока (пока только игрока, без соперника)
		// - таких координат 2 набора - графический и физический
		
		const carX = this.car.getPhysBodyPosition().x;
		const carY = this.car.getPhysBodyPosition().y;
		const carZ = this.car.getPhysBodyPosition().z;
		
		// координаты 0, 0 - в центре квадрата 0, 0   
		const cellPhysX = Math.round(carX / this.TERRAIN_PHYS_SQUARE_SIZE);  
		const cellPhysZ = Math.round(carZ / this.TERRAIN_PHYS_SQUARE_SIZE);
		
		let st = document.getElementById("cellPhysX");
		if (st != null) {
			st.innerHTML = "" + cellPhysX;
		}
		st = document.getElementById("cellPhysZ");
		if (st != null) {
			st.innerHTML = "" + cellPhysZ;
		}

		const carXRounded = cellPhysX * this.TERRAIN_PHYS_SQUARE_SIZE; 
		let x1;
		let x2;
		if (carX == carXRounded) {
			x1 = cellPhysX;
			x2 = x1;
		} else if (carX < carXRounded) {
			x1 = cellPhysX - 1;
			x2 = cellPhysX;
		} else {
			x1 = cellPhysX;
			x2 = cellPhysX + 1;
		}
		
		const carZRounded = cellPhysZ * this.TERRAIN_PHYS_SQUARE_SIZE; 
		let z1;
		let z2;
		if (carZ == carZRounded) {
			z1 = cellPhysZ;
			z2 = z1;
		} else if (carZ < carZRounded) {
			z1 = cellPhysZ - 1;
			z2 = cellPhysZ;
		} else {
			z1 = cellPhysZ;
			z2 = cellPhysZ + 1;
		}
		
		// создаём список актуальных физических квадратов
		const newPhysSquaresList: string[] = [];
		
		const newPhysStringsList: string[] = [];  // пусть тоже string, для единообразия
		
		// создаём от 1 до 4 физических квадратов поверхности
		// - если уже созданы, то не создаём
		// - неактуальные квадраты удаляем
		for (let z = z1; z <= z2; z++) {
			
			
			for (let x = x1; x <= x2; x++) {
				
				const key = "" + x + ":" + z; 
				
				newPhysSquaresList.push(key);
				
				const square = this.physSquares.get(key);
//				console.log("square = " + square);
				
				if (square === undefined) {
					// создаём физический квадрат
//					console.log("создаём физический квадрат с key = " + key + "; carX = " + carX + ", carZ = " + carZ);
				
					const body = this.createTerrainPhysSquare(x, z);
					
					this.physSquares.set(key, body);
					
					// визуализация физического квадрата (для отладки)
					const physVysObject = new THREE.Object3D();
					this.visibleObjectPhysSquares.add(physVysObject);
					
					this.physSquaresVisual.set(key, physVysObject);
					
					this.physVisUtil.addVisual(physVysObject, body, "trimesh", "physTerrain", 0.1);

					
				}
				
			}
			
			// дорожная насыпь
			
			if (this.gameMode != 'trophy') {
				
				const stringKey = "" + z;
			
				newPhysStringsList.push(stringKey);
			
				const str = this.physStrings.get(stringKey);
				if (str === undefined) {
					// создаём физическую строку насыпи
//					console.log("создаём физическую строку насыпи с key = " + stringKey + "; carX = " + carX + ", carZ = " + carZ);
				
						const body: CANNON.Body = this.createRoadPhysString(z);
					
						this.physStrings.set(stringKey, body);
					
						// визуализация (для отладки)
						const physVysObject = new THREE.Object3D();
						this.visibleObjectPhysStrings.add(physVysObject);
					
						this.physStringsVisual.set(stringKey, physVysObject);
					
						this.physVisUtil.addVisual(physVysObject, body, "trimesh", "physTerrain", 0.1);
				
				}
			
			}
			
			
			
			
			
			
			
		}
		
		//console.log("удаляем старые, более неактуальные физические квадраты");
		
		// удаляем старые, более неактуальные физические квадраты
		for (let i = 0; i < this.physSquaresList.length; i++) {  // скан по предыдущему списку квадратов
			const key = this.physSquaresList[i];
			if (newPhysSquaresList.indexOf(key) == -1) {  // в новом списке такого квадрата нет 
				// - удаляем его body из world
//				console.log("удаляем физический квадрат с key = " + key + "; carX = " + carX + ", carZ = " + carZ);

				const body = this.physSquares.get(key);
				
//				console.log("body = " + body);
				
				if (body !== undefined) {   
					this.worldCannon.removeBody(body);
					
					this.physSquares.delete(key);
					
				}
				
				// также удаляем визуализацию удалённого квадрата
				const physVysObject = this.physSquaresVisual.get(key);
				if (physVysObject != undefined) {
					this.visibleObjectPhysSquares.remove(physVysObject);
					this.removeObjWithChildren(physVysObject);
					physVysObject.removeFromParent();
				}
				
				
			}
			
			
		}

		// заменяем старый список новым		
		this.physSquaresList = newPhysSquaresList;

		// то же самое делаем для физических строк дорожной насыпи
		for (let i = 0; i < this.physStringsList.length; i++) {  // скан по предыдущему списку строк
			const key = this.physStringsList[i];
			if (newPhysStringsList.indexOf(key) == -1) {  // в новом списке такого квадрата нет 
				// - удаляем его body из world
//				console.log("удаляем физическую строку с key = " + key + "; carX = " + carX + ", carZ = " + carZ);

				const body = this.physStrings.get(key);
				
//				console.log("body = " + body);
				
				if (body !== undefined) {   
					this.worldCannon.removeBody(body);
					
					this.physStrings.delete(key);
					
				}
				
				// также удаляем визуализацию удалённой строки
				const physVysObject = this.physStringsVisual.get(key);
				if (physVysObject != undefined) {
					this.visibleObjectPhysStrings.remove(physVysObject);
					this.removeObjWithChildren(physVysObject);
					physVysObject.removeFromParent();
				}
				
			}
			
			
		}
		




		this.physStringsList = newPhysStringsList;

		st = document.getElementById("physSquares");
		if (st != null) {
			st.innerHTML = "" + newPhysSquaresList.toString();
		}
		

		st = document.getElementById("numPhysSquares");
		if (st != null) {
			st.innerHTML = "" + this.physSquaresList.length;
		}
		
		
//		this.world.step(1/60);
///		for (let i = 0; i < 10; i++) {
		for (let i = 0; i < 1; i++) {
//		for (let i = 0; i < 2; i++) {
//			this.world.step(1/600);
			//this.world.step(1/200);
//			this.world.step(1/100);
//		}
//		this.world.step(1/240);

		// анализируем поверхность под колёсами, настраиваем каждое
		this.car.updateWheels();
		
		

		this.worldCannon.step(1/60);
//		this.world.step(1/30);
		
		
			this.car.animate();

		}

		
		// графика поверхности
		const carCellGraphZ = Math.round(carZ / this.TERRAIN_GRAPH_SQUARE_SIZE);  // в какой клеточной строке находится машина
		
		// актуализация списка графических квадратов, моделинг новых, удаление ненужных старых
		const newGraphSquaresList: string[] = [];
		
		// строки графических квадратов
		let numGraphLayers;
		if (!this.isPlayerPlace) {
			numGraphLayers = this.TERRAIN_NUM_GRAPH_LAYERS;
		} else {
			numGraphLayers = this.TERRAIN_NUM_GRAPH_LAYERS_PLAYER_PLACE;
		}
		
		for (let layerZ: number = -numGraphLayers; layerZ <= numGraphLayers; layerZ++) {
			
			const cellGraphZ = carCellGraphZ + layerZ; 
			
			// столбцы графических квадратов
			for (let layerX: number = -numGraphLayers; layerX <= numGraphLayers; layerX++) {
				// клеточную координату X определяем относительно координаты дороги
				// - пока нет
				const cellGraphX = Math.round(carX / this.TERRAIN_GRAPH_SQUARE_SIZE) + layerX;  
				
				const key = "" + cellGraphX + ":" + cellGraphZ; 
				newGraphSquaresList.push(key);
				let square = this.graphSquares.get(key);
				if (square == undefined) {  // если такого квадрата нет, создаём
					// создаём графический квадрат
//					console.log("создаём графический квадрат с key = " + key);
					square = this.createTerrainGraphSquare(cellGraphX, cellGraphZ);
					this.sceneRootObject.add(square);
					this.graphSquares.set(key, square);
				}
				
				// экспериментальный искусственный горизонт
///				square.position.y = -Math.abs(Math.pow(carZ - cellGraphZ * this.TERRAIN_GRAPH_SQUARE_SIZE, 3)) * 0.00000005;
				// - на прямой плоской дороге отлично смотрится
				// - на извилистой холмистой заметны ступени, а горизонт недостаточен (видны появления/проявления гор)
				
///				square.position.y = -Math.abs(Math.pow(carZ - cellGraphZ * this.TERRAIN_GRAPH_SQUARE_SIZE, 4)) * 0.0000000005;
				

//				square.position.y = -Math.abs(Math.pow(
//					Math.pow(carZ - cellGraphZ * this.TERRAIN_GRAPH_SQUARE_SIZE, 2) 
//					+ Math.pow(carX - cellGraphX * this.TERRAIN_GRAPH_SQUARE_SIZE, 2), 3)) * 0.000000000000001;

				
///				square.position.y = -Math.abs(Math.pow(
///					Math.pow(carZ - cellGraphZ * this.TERRAIN_GRAPH_SQUARE_SIZE, 2) 
///					+ Math.pow(carX - cellGraphX * this.TERRAIN_GRAPH_SQUARE_SIZE, 2), 3.3)) * 0.00000000000000001;
				
				
				//if ((layerZ == -numGraphLayers) || (layerZ == numGraphLayers) || (layerX == -numGraphLayers) || (layerX == numGraphLayers)) {
					
				const r2 = Math.pow(carZ - cellGraphZ * this.TERRAIN_GRAPH_SQUARE_SIZE, 2) 
						+ Math.pow(carX - cellGraphX * this.TERRAIN_GRAPH_SQUARE_SIZE, 2); 	
						
				square.position.y = -Math.abs(Math.pow(r2, 3.75)) * 0.00000000000000001;
					
				//} else {
					//square.position.y = 0;
				//}	
				
				
				
				
				
				
			}		
		
		}
		
		
		// удаляем старые, более неактуальные графические квадраты
		for (let i = 0; i < this.graphSquaresList.length; i++) {
			const key = this.graphSquaresList[i];
			if (newGraphSquaresList.indexOf(key) == -1) {
				// в новом списке такого квадрата нет, удаляем его объект из 3D-сцены
//				console.log("удаляем графический квадрат с key = " + key + "; carX = " + carX + ", carZ = " + carZ);

				const object = this.graphSquares.get(key);
				if (object != undefined) {
					
					this.sceneRootObject.remove(object);
					this.removeObjWithChildren(object);
					object.removeFromParent();
					
					this.graphSquares.delete(key);
					
				}
				
			}
			
			
		}

		// заменяем старый список новым		
		this.graphSquaresList = newGraphSquaresList;
		
		st = document.getElementById("numGraphSquares");
		if (st != null) {
			st.innerHTML = "" + this.graphSquaresList.length;
		}
		
		
		
		///
		
		st = document.getElementById("numPolygons");
		if (st != null) {
			st.innerHTML = "" + this.renderer.info.render.triangles;
		}
		
		
		st = document.getElementById("numSceneElements");
		if (st != null) {
			st.innerHTML = "" + this.scene.children.length;
		}
		
		st = document.getElementById("numMapElements");
		if (st != null) {
			st.innerHTML = "" + this.sceneRootObject.children.length; 
		}
		
		st = document.getElementById("numPhysWorldElements");
		if (st != null) {
			st.innerHTML = "" + this.worldCannon.bodies.length; 
		}
		
		this.physVisUtil.updateVisuals();
		
		this.car.updateVisuals();
		
		
		if (this.cameraMode == "chaseCopter") {
			// прицепляю камеру к автомобилю
			if (this.cameraEngineChaseCopter != null) {
			
				const position = this.car.getPhysBodyPosition();
				
//				console.log("car.position = " + position);
				
				const quaternion = this.car.getPhysBodyQuaternion();
			
				this.cameraEngineChaseCopter.animate(position, quaternion);
			
//				console.log("velocity = " + this.car.getPhysBodyVelocity());  // вектор
			
			}
			
		} else {
			
			this.cameraEngineOrbital.animate();
			
		}
		
		// воду двигаем вместе с машиной
		this.water.position.x = carX;
		this.water.position.z = carZ;

		// аналогично двигаем солнышко, чтобы машина и ближайшие к ней объекты всегда отбрасывали тени
		this.directionalLight.position.set(-1000 + carX, 500 + carY, 0 + carZ);
		this.directionalLight.target.position.set(1000 + carX, -500 + carY, 0 + carZ);

		// это всё потом надо прореживать, не в каждом кадре менять
		// (лучше даже сделать зависимость от расстояния перемещения с последнего апдейта)
		this.directionalLight.target.updateMatrixWorld();
		this.directionalLight.shadow.camera.updateProjectionMatrix();
		
		this.lightHelper.update();
		this.shadowCameraHelper.update();		


		this.stats.update();
		
		// экспериментальный горизонт для стартового и финишного знаков
		if (this.signStart != null) {
			const r2 = Math.pow(carZ - this.signStart.startPosition.z, 2) 
					+ Math.pow(carX - this.signStart.startPosition.x, 2); 	
						
			this.signStart.screenObject.position.y = this.signStart.startPosition.y - Math.abs(Math.pow(r2, 3.75)) * 0.00000000000000001;
		}
		if (this.signFinish != null) {
			const r2 = Math.pow(carZ - this.signFinish.startPosition.z, 2) 
					+ Math.pow(carX - this.signFinish.startPosition.x, 2); 	
						
			this.signFinish.screenObject.position.y = this.signFinish.startPosition.y - Math.abs(Math.pow(r2, 3.75)) * 0.00000000000000001;
		}
		
		const pStatus = document.getElementById("gameSpecsStatus");
		if (pStatus != null) {
			if (this.gameMode == "trophy") {
				const pDist = document.getElementById("gameSpecsControlPointDistance");
				if (this.currentTrophyPointNumber < this.trophyControlPoints.length) {
					pStatus.innerHTML = "пройдено " + this.currentTrophyPointNumber + " из " + this.trophyControlPoints.length + " контрольных точек";
					
					// считаем расстояние
					const r2 = Math.pow(carZ - this.trophyControlPoints[this.currentTrophyPointNumber].startPosition.z, 2) 
						+ Math.pow(carX - this.trophyControlPoints[this.currentTrophyPointNumber].startPosition.x, 2); 	
					
					if (pDist != null) {
						pDist.innerHTML = Math.sqrt(r2) + " м";
					}
					
					// проверяем расстояние до текущей точки, если маленькое, то отмечаем точку пройденной
					if (r2 < 9) {
						// перекрашиваем точку
						this.trophyControlPoints[this.currentTrophyPointNumber].repaintTo(0x00FF00);
						this.currentTrophyPointNumber++;	
					}
					
					
				} else {
					pStatus.innerHTML = "пройдены все точки, победа!!!";
					
					if (pDist != null) {
						pDist.innerHTML = "";
					}

					const pDistCaption = document.getElementById("gameSpecsControlPointDistanceCaption");
					if (pDistCaption != null) {
						pDistCaption.innerHTML = "";
					}

					
				}
			} else if (this.gameMode == 'drag' || this.gameMode == 'rally') {
				// проверка на прохождение финиша (через него нужно проехать по дороге)
				
				const road = this.getRoad(carZ);
				
				if ((carZ < this.signFinish.screenObject.position.z) && (carX >= road.roadLeft)  && (carX <= road.roadRight)) {
					pStatus.innerHTML = "финишировал, победа!!!";
				}
				
			}
		}

		// горизонт и вращение для контрольных точек
		for (let i = 0; i < this.trophyControlPoints.length; i++) {
			
			const controlPoint = this.trophyControlPoints[i]; 
			
			const r2 = Math.pow(carZ - controlPoint.startPosition.z, 2) 
					+ Math.pow(carX - controlPoint.startPosition.x, 2); 	
						
			controlPoint.screenObject.position.y = controlPoint.startPosition.y - Math.abs(Math.pow(r2, 3.75)) * 0.00000000000000001;
			
			controlPoint.screenObject.rotateY(0.02);
			
			
			
		}
		
		
				

		this.renderer.render(this.scene, this.camera);

	}
	///////////////////////////////////////////////////////////////////////////////////
	removeObjWithChildren(obj: any) {
		if (obj.children.length > 0) {
			for (let x = obj.children.length - 1; x >= 0; x--) {
				this.removeObjWithChildren(obj.children[x])
			}
		}
		if (obj.isMesh) {
			obj.geometry.dispose();
			obj.material.dispose();
		}
		if (obj.parent) {
			obj.parent.remove(obj)

		}
	}	
	///////////////////////////////////////////////////////////////////////////////////
	createTerrainPhysSquare(cellX: number, cellZ: number) {
		// генерируем физический квадрат со стороной this.TERRAIN_PHYS_SQUARE_SIZE и центром cellX, cellZ (координаты клеточные; 0, 0 - в середине клетки) 
		
//		console.log("createTerrainPhysSquare, cellX = " + cellX + ", cellZ = " + cellZ);
		
		// первый проход - расчёт высот в узлах карты; считаем на 1 узел дальше по каждой оси, поэтому <=, а не < 
		
		// карту высот строю по максимальной высоте земли/гор

		const TERRAIN_PHYS_SQUARE_SIZE_HALF = this.TERRAIN_PHYS_SQUARE_SIZE / 2;  // 20/2 = 10

		// оставлю 4 точки, без субделений
//		const left = cellX * this.TERRAIN_PHYS_SQUARE_SIZE - TERRAIN_PHYS_SQUARE_SIZE_HALF; 
//		const right = cellX * this.TERRAIN_PHYS_SQUARE_SIZE + TERRAIN_PHYS_SQUARE_SIZE_HALF;
//		const close = cellZ * this.TERRAIN_PHYS_SQUARE_SIZE - TERRAIN_PHYS_SQUARE_SIZE_HALF; 
//		const far = cellZ * this.TERRAIN_PHYS_SQUARE_SIZE + TERRAIN_PHYS_SQUARE_SIZE_HALF;
		

		const physVertices = [];
		
		
		
		let cX = 0;
		let cY = 0;
		let cZ = 0;

		const physVecVerticesCommon: CANNON.Vec3[] = [];
		
		
//		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC <= TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += this.TERRAIN_PHYS_RESOLUTION) {
		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC <= TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += this.TERRAIN_PHYS_SQUARE_SIZE) {
			
			const z = cellZ * this.TERRAIN_PHYS_SQUARE_SIZE + iC;  // метры карты; 0 - в центре
			
//			for (let jC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; jC <= TERRAIN_PHYS_SQUARE_SIZE_HALF; jC += this.TERRAIN_PHYS_RESOLUTION) {
			for (let jC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; jC <= TERRAIN_PHYS_SQUARE_SIZE_HALF; jC += this.TERRAIN_PHYS_SQUARE_SIZE) {

				const x = cellX * this.TERRAIN_PHYS_SQUARE_SIZE + jC;
				
				
				const obj = this.getTerrainPoint(x, z);
				
				// из max(rock, ground) каждого узла строим физическую сетку
				const vCur = new THREE.Vector3(x, Math.max(obj.rock, obj.ground), z);
				
				physVertices.push(vCur.x);
				physVertices.push(vCur.y);
				physVertices.push(vCur.z);
				
				cX += vCur.x;
				cY += vCur.x;
				cZ += vCur.x;
				
				physVecVerticesCommon.push(new CANNON.Vec3(vCur.x, vCur.y, vCur.z));
				//physVecVertices.push(new CANNON.Vec3(vCur.x, vCur.y, vCur.z));
				
				
				// второй слой для convex - ниже первого
				//physVertices.push(vCur.x);
				//physVertices.push(vCur.y - 0.1);
				//physVertices.push(vCur.z);
				//physVecVertices.push(new CANNON.Vec3(vCur.x, vCur.y - 0.1, vCur.z));
				
			}
			
		}
		
///		const bottomPoint: CANNON.Vec3 = new CANNON.Vec3(cX / physVecVerticesCommon.length, cY / physVecVerticesCommon.length - 1000, cZ / physVecVerticesCommon.length); 
		const bottomPoint: CANNON.Vec3 = new CANNON.Vec3(cX / physVecVerticesCommon.length, cY / physVecVerticesCommon.length - 10000, cZ / physVecVerticesCommon.length); 
		
		// физический квадрат делю на 2 многогранника, каждый будет из 4 вершин (пирамидка основанием вверх)
		const physVecVertices: CANNON.Vec3[] = [];
		const physVecVertices1: CANNON.Vec3[] = [];
		
		const physFaces: number[][] = [];
		const physFaces1: number[][] = [];
		
		// в physVecVerticesCommon - точки рабочей грани
		// добавляю к ним нижнюю точку
		physVecVertices.push(physVecVerticesCommon[0]);
		physVecVertices.push(physVecVerticesCommon[2]);
		physVecVertices.push(physVecVerticesCommon[3]);
		physVecVertices.push(bottomPoint);
		
		physVecVertices1.push(physVecVerticesCommon[0]);
		physVecVertices1.push(physVecVerticesCommon[3]);
		physVecVertices1.push(physVecVerticesCommon[1]);
		physVecVertices1.push(bottomPoint);
		
		
		// первый многогранник
		// верх
		const face: number[] = [];  
		face.push(0);
		face.push(1);
		face.push(2);
		physFaces.push(face);

		// низ-левый
		const face1: number[] = [];  
		face1.push(0);
		face1.push(1);
		face1.push(3);
		physFaces.push(face1);
		
		// низ-правый 
		const face2: number[] = [];  
		face2.push(0);
		face2.push(2);
		face2.push(3);
		physFaces.push(face2);
		
		// низ-дальний
		const face3: number[] = [];  
		face3.push(1);
		face3.push(2);
		face3.push(3);
		physFaces.push(face3);
		
		// второй многогранник
		// верх
		const face4: number[] = [];  
		face4.push(0);
		face4.push(1);
		face4.push(2);
		physFaces1.push(face4);

		// низ-левый
		const face5: number[] = [];  
		face5.push(0);
		face5.push(1);
		face5.push(3);
		physFaces1.push(face5);
		
		// низ-правый 
		const face6: number[] = [];  
		face6.push(1);
		face6.push(2);
		face6.push(3);
		physFaces1.push(face6);
		
		// низ-ближний
		const face7: number[] = [];  
		face7.push(0);
		face7.push(2);
		face7.push(3);
		physFaces1.push(face7);
		
		
		
		
		
		
		
		
		// второй проход - на основе карты высот строим физическую сетку
		const physIndices = [];
		
		let i = 0;
	
		const physSquareVerticesCount = this.TERRAIN_PHYS_SQUARE_SIZE / this.TERRAIN_PHYS_RESOLUTION;   	
	
		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC < TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += this.TERRAIN_PHYS_RESOLUTION) {
			
			let j = 0;
			
			for (let jC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; jC < TERRAIN_PHYS_SQUARE_SIZE_HALF; jC += this.TERRAIN_PHYS_RESOLUTION) {
			
				// строим физическую сетку (индексы вершин)
				/*
				physIndices.push(i * (physSquareVerticesCount + 1) + j);
				physIndices.push(i * (physSquareVerticesCount + 1) + j + 1);
				physIndices.push((i + 1) * (physSquareVerticesCount + 1) + j + 1);
				
				physIndices.push(i * (physSquareVerticesCount + 1) + j);
				physIndices.push((i + 1) * (physSquareVerticesCount + 1) + j + 1);
				physIndices.push((i + 1) * (physSquareVerticesCount + 1) + j);
				*/
				
				/*
				let face: number[] = [];  // верх
				face.push(i * (physSquareVerticesCount*2 + 1) + j);
				face.push(i * (physSquareVerticesCount*2 + 1) + j + 1);
				face.push((i + 1) * (physSquareVerticesCount*2 + 1) + j + 1);
				physFaces.push(face);

				face = [];  // низ
				face.push(i * (physSquareVerticesCount*2 + 1) + j + 1);
				face.push(i * (physSquareVerticesCount*2 + 1) + j + 1 + 1);
				face.push((i + 1) * (physSquareVerticesCount*2 + 1) + j + 1 + 1);
				physFaces.push(face);
				*/
				
				j++;
				
			}
			
			i++;
		}

		const body: CANNON.Body = new CANNON.Body({ mass: 0, material: this.groundMaterial });

//			console.log("physVertices.length = " + physVertices.length);
//			console.log("physIndices.length = " + physIndices.length);
			
			//const shape: CANNON.Trimesh = new CANNON.Trimesh(physVertices, physIndices);
//			const shape: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron({props: {vertices: physVertices, faces: physFaces}});
			//const shape: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron(physVecVertices, physFaces);
			
			const normals = this.computeFaceNormals(physVecVertices, physFaces);
			const shape: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron({vertices: physVecVertices, faces: physFaces, normals: normals});
			body.addShape(shape);

			const normals1 = this.computeFaceNormals(physVecVertices1, physFaces1);
			const shape1: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron({vertices: physVecVertices1, faces: physFaces1, normals: normals1});
			body.addShape(shape1);
			
			this.worldCannon.addBody(body);
			
		return body;
	}
	///////////////////////////////////////////////////////////////////////////////////
	createRoadPhysString(cellZ: number) {
//		console.log("createRoadBankPhysString, cellZ = " + cellZ);
		
		// насыпь строим так же, в два прохода (из-за индексирования вершин)
		
		// первый проход - расчёт высот в узлах карты; считаем на 1 узел дальше по каждой оси, поэтому <=, а не < 
		
		const physVertices = [];
		
		const TERRAIN_PHYS_SQUARE_SIZE_HALF = this.TERRAIN_PHYS_SQUARE_SIZE / 2;

		const body: CANNON.Body = new CANNON.Body({ mass: 0, material: this.roadMaterial });
	
//		const zStep = this.TERRAIN_PHYS_SQUARE_SIZE;
		const zStep = this.ROAD_PHYS_RESOLUTION;
		
		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC < TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += zStep) {

			
			const z = cellZ * this.TERRAIN_PHYS_SQUARE_SIZE + iC;  // метры карты; 0 - в центре
			
			const zFar = z + zStep;
			
			const road = this.getRoad(z);
			const roadFar = this.getRoad(zFar);
			
			const height = road.heightM + this.ROAD_BANK_HEIGHT;
			const heightFar = roadFar.heightM + this.ROAD_BANK_HEIGHT;
			
			/*
			// левый откос дорожной насыпи
			physVertices.push(road.roadLeft - this.ROAD_BANK_WIDTH);
			physVertices.push(road.heightM);
			physVertices.push(z);
			
			physVertices.push(road.roadLeft);
			physVertices.push(height);
			physVertices.push(z);
			
			// дорога
			physVertices.push(road.roadLeft);
			physVertices.push(height);
			physVertices.push(z);
			
			physVertices.push(road.roadLeft + 2 * this.ROAD_HALF_WIDTH);
			physVertices.push(height);
			physVertices.push(z);
			
			// правый откос дорожной насыпи
			physVertices.push(road.roadLeft + 2 * this.ROAD_HALF_WIDTH);
			physVertices.push(height);
			physVertices.push(z);
			
			physVertices.push(road.roadLeft + 2 * this.ROAD_HALF_WIDTH + this.ROAD_BANK_WIDTH);
			physVertices.push(road.heightM);
			physVertices.push(z);
			*/
			
			// строим многоугольники - 4 штуки на каждое субделение дороги
			//const physVecVertices1: CANNON.Vec3[] = [];
			//const physVecVertices2: CANNON.Vec3[] = [];
			//const physVecVertices3: CANNON.Vec3[] = [];
			//const physVecVertices4: CANNON.Vec3[] = [];
			
			// массив вершин субделения
			const physVecVertices: CANNON.Vec3[] = [];
			// верх
			physVecVertices.push(new CANNON.Vec3(road.roadLeft, height, z));
			physVecVertices.push(new CANNON.Vec3(road.roadRight, height, z));
			physVecVertices.push(new CANNON.Vec3(roadFar.roadRight, heightFar, zFar));
			physVecVertices.push(new CANNON.Vec3(roadFar.roadLeft, heightFar, zFar));
			// низ
			physVecVertices.push(new CANNON.Vec3(road.roadLeft - this.ROAD_BANK_WIDTH, road.heightM, z));
			physVecVertices.push(new CANNON.Vec3(road.roadRight + this.ROAD_BANK_WIDTH, road.heightM, z));
			physVecVertices.push(new CANNON.Vec3(roadFar.roadRight + this.ROAD_BANK_WIDTH, roadFar.heightM, zFar));
			physVecVertices.push(new CANNON.Vec3(roadFar.roadLeft - this.ROAD_BANK_WIDTH, roadFar.heightM, zFar));


			const physFaces: number[][] = [];
			
			const face1: number[] = [];  
			face1.push(0);
			face1.push(2);
			face1.push(1);
			physFaces.push(face1);

			const face2: number[] = [];  
			face2.push(0);
			face2.push(3);
			face2.push(2);
			physFaces.push(face2);

			const face3: number[] = [];  
			face3.push(0);
			face3.push(7);
			face3.push(3);
			physFaces.push(face3);

			const face4: number[] = [];  
			face4.push(0);
			face4.push(4);
			face4.push(7);
			physFaces.push(face4);

			const face5: number[] = [];  
			face5.push(2);
			face5.push(5);
			face5.push(1);
			physFaces.push(face5);

			const face6: number[] = [];  
			face6.push(2);
			face6.push(4);
			face6.push(5);
			physFaces.push(face6);

			const face8: number[] = [];  
			face8.push(4);
			face8.push(0);
			face8.push(5);
			physFaces.push(face8);

			const face9: number[] = [];  
			face9.push(1);
			face9.push(5);
			face9.push(0);
			physFaces.push(face9);

			const face10: number[] = [];  
			face10.push(3);
			face10.push(7);
			face10.push(2);
			physFaces.push(face10);

			const face11: number[] = [];  
			face11.push(7);
			face11.push(6);
			face11.push(2);
			physFaces.push(face11);

			const face7: number[] = [];  
			face7.push(7);
			face7.push(4);
			face7.push(5);
			physFaces.push(face7);

			const face12: number[] = [];  
			face12.push(7);
			face12.push(5);
			face12.push(6);
			physFaces.push(face12);


			const normals = this.computeFaceNormals(physVecVertices, physFaces);
			const shape: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron({vertices: physVecVertices, faces: physFaces, normals: normals});
//			const shape: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron({vertices: physVecVertices, faces: physFaces});
//shape.computeNormals();
			body.addShape(shape);


/*
			// пробую разбивать на треугольные пирамидки вершиной вниз (так же, как основную поверхность уровня)
			const physVecVertices1: CANNON.Vec3[] = [];
			physVecVertices1.push(physVecVertices[0]);
			physVecVertices1.push(physVecVertices[1]);
			physVecVertices1.push(physVecVertices[2]);
			physVecVertices1.push(new CANNON.Vec3((physVecVertices[0].x + physVecVertices[2].x) / 2, 
//				-10000, 
				(physVecVertices[4].y + physVecVertices[6].y) / 2, 
				(physVecVertices[0].z + physVecVertices[2].z) / 2));
			
			const physFaces1: number[][] = [];
			const faceD11: number[] = [];  
			faceD11.push(0);
			faceD11.push(1);
			faceD11.push(2);
			physFaces1.push(faceD11);
			const faceD12: number[] = [];  
			faceD12.push(0);
			faceD12.push(1);
			faceD12.push(3);
			physFaces1.push(faceD12);
			const faceD13: number[] = [];  
			faceD13.push(0);
			faceD13.push(2);
			faceD13.push(3);
			physFaces1.push(faceD13);
			const faceD14: number[] = [];  
			faceD14.push(1);
			faceD14.push(2);
			faceD14.push(3);
			physFaces1.push(faceD14);
			
			const shape1: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron({vertices: physVecVertices1, faces: physFaces1});
shape1.computeNormals();
			body.addShape(shape1);
			
			const physVecVertices2: CANNON.Vec3[] = [];
			physVecVertices2.push(physVecVertices[0]);
			physVecVertices2.push(physVecVertices[2]);
			physVecVertices2.push(physVecVertices[3]);
			physVecVertices2.push(new CANNON.Vec3((physVecVertices[0].x + physVecVertices[2].x) / 2, 
//				-10000, 
				(physVecVertices[4].y + physVecVertices[6].y) / 2, 
				(physVecVertices[0].z + physVecVertices[2].z) / 2));
			
			const physFaces2: number[][] = [];
			const faceD21: number[] = [];  
			faceD21.push(0);
			faceD21.push(1);
			faceD21.push(2);
			physFaces2.push(faceD21);
			const faceD22: number[] = [];  
			faceD22.push(0);
			faceD22.push(1);
			faceD22.push(3);
			physFaces2.push(faceD22);
			const faceD23: number[] = [];  
			faceD23.push(0);
			faceD23.push(2);
			faceD23.push(3);
			physFaces2.push(faceD23);
			const faceD24: number[] = [];  
			faceD24.push(1);
			faceD24.push(2);
			faceD24.push(3);
			physFaces2.push(faceD24);
			
			const shape2: CANNON.ConvexPolyhedron = new CANNON.ConvexPolyhedron({vertices: physVecVertices2, faces: physFaces2});
shape2.computeNormals();
			body.addShape(shape2);
*/
			
		}
		
		this.worldCannon.addBody(body);
			
		
		return body;
	}
	///////////////////////////////////////////////////////////////////////////////////
	getRoad(z: number) {
		
		const pz = (z / 4 + 128) * 2 / 256;

		// изгибы дороги - сдвигами влево-вправо (возвраты и самопересечения невозможны) 
		const roadLeft = this.straightRoad ? 0 : this.ROAD_AMPLITUDE_X * this.noise2D(pz / 4, 0) - this.ROAD_HALF_WIDTH;
		const roadRight = roadLeft + this.ROAD_HALF_WIDTH * 2;
			
		const roadLeftRock = roadLeft - this.ROAD_HALF_WIDTH_ROCK;
		const roadRightRock = roadLeft + this.ROAD_HALF_WIDTH_ROCK * 2;

		const roadLeftGround = roadLeft - this.ROAD_HALF_WIDTH_GROUND;
		const roadRightGround = roadLeft + this.ROAD_HALF_WIDTH_GROUND * 2;
			
		// модуляция высоты местности вдоль оси дороги 
		const heightM = this.flatRoad ? 0 : this.ROAD_AMPLITUDE_Y * this.noise2D(pz / 4, 0);
		
		const obj = { roadLeft: roadLeft,
			roadRight: roadRight,
			roadLeftRock: roadLeftRock,
			roadRightRock: roadRightRock,
			roadLeftGround: roadLeftGround,
			roadRightGround: roadRightGround,
			heightM: heightM,
			inWater: (heightM <= this.WATER_HEIGHT)
		};
		
		return obj;
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	getTerrainPoint(x: number, z: number) {
		// из координат точки добываем высоту земли, скал 

		const road = this.getRoad(z);

		const pz = (z / 4 + 128) * 2 / 256;
		
		const px = (x / 4 + 128) * 2 / 256;
				
		// горы
		const noise1 = this.noise2D(pz / 4, px / 4);
		const noise2 = this.noise2D(px / 2, pz / 2);
				
		let height = this.MAX_HEIGHT_ROCK * this.noise2D(noise1 + pz * 2, Math.abs(noise2) + px) - 20;
				
		// дополнительная модуляция для получения более реалистичных гор
//		const height1 = 100 * this.noise2D(pz, px);
//		const height2 = 20 * this.noise2D(pz * 16, px * 16);
//		const height3 = 10 * this.noise2D(pz * 32, px * 32);
		const height1 = 50 * this.noise2D(pz, px);
		const height2 = 20 * this.noise2D(pz * 16, px * 16);
		const height3 = 10 * this.noise2D(pz * 32, px * 32);
		
		let heightMod = height1 + height2 + height3;
		
		if (this.isPlayerPlace) {  // делаем гору игрока повыразительнее
			heightMod *= 2;
		}
		
				
		height += heightMod;
		
		if (height < 0) {  // подземные горы пусть немножко остаются, для прорывов камня в низинах
			height *= 0.25;
		}

		if ((x >= road.roadLeftRock) && (x < road.roadRightRock)) {
			// область гор под дорогой уводим вниз; на нескоростных трассах потом можно наоборот, оставить выступчики, пусть объезжают
			height = -0.5;
		} else {
			// сглаживание прилегающих к дороге поверхностей (самое простое, линейное)
			let slopeLeft = road.roadLeftRock - this.ROAD_SLOPE_WIDTH_ROCK;
			let slopeRight = road.roadLeftRock;

			if ((x >= slopeLeft) && (x < slopeRight)) {
				const multiplier = (slopeRight - x) / this.ROAD_SLOPE_WIDTH_ROCK; 
				height *= multiplier;
			} else {
				slopeLeft = road.roadRightRock;  
				slopeRight = road.roadRightRock + this.ROAD_SLOPE_WIDTH_ROCK;
						
				if ((x >= slopeLeft) && (x < slopeRight)) {
					const multiplier = (x - slopeLeft) / this.ROAD_SLOPE_WIDTH_ROCK; 
					height *= multiplier;
				}
			}
					
		}

		height += road.heightM;

		if (this.isPlayerPlace) {
			// добавляем гору - расположение владения игрока
			if ((x > 20) && (x < 420)) {
				if ((z > -300) && (z < 300)) {
					
					const mountH = (200 - Math.abs(x - 220)) * (300 - Math.abs(z)) / 300;
					
					height += mountH;
					
					// формируем место под дверь
					
					if ((x < 26) && (Math.abs(z) < 8)) {
						// вырезаем дырку под тамбур
						height = -1000;
					} else if ((x < 26) && (Math.abs(z) < 12)) {
						height = 0.1;
					}
					
				}
			}
			
		}


		let heightRock = height;
				
		// земля
		height = this.MAX_HEIGHT_GROUND * this.noise2D(pz * 3, px * 3);

		if ((x >= road.roadLeftGround) && (x < road.roadRightGround)) {
			// дорога всегда ровная (лучше бы в поворотах чуть наклонять, но пока не усложнем)
			height = 0;
		} else {
			// сглаживание прилегающих к дороге поверхностей (самое простое, линейное)
			let leftSlopeX = road.roadLeftGround - this.ROAD_SLOPE_WIDTH_GROUND;
			let rightSlopeZ = road.roadLeftGround;
			if ((x >= leftSlopeX) && (x < rightSlopeZ)) {
				const multiplier = (rightSlopeZ - x) / this.ROAD_SLOPE_WIDTH_GROUND; 
				height *= multiplier;
			} else {
				leftSlopeX = road.roadRightGround;  
				rightSlopeZ = road.roadRightGround + this.ROAD_SLOPE_WIDTH_GROUND;
				if ((x >= leftSlopeX) && (x < rightSlopeZ)) {
					const multiplier = (x - leftSlopeX) / this.ROAD_SLOPE_WIDTH_GROUND; 
					height *= multiplier;
				}
			}
				
		}

		// модуляция высоты местности вдоль оси дороги 
		height += road.heightM;

		// если точка горы заметно ниже точки земли, то приподнимаем 
		// - это нужно с целью снизить артефакты невидимых возвышений у гор
		if (heightRock > -1000) {
			const rockFixDepthHeight = 0.1; 
			if (heightRock < (height - rockFixDepthHeight)) {
				heightRock = height - rockFixDepthHeight;
			}
		}
		
		if (this.isPlayerPlace) {
			if ((x > 20) && (x < 100) && (Math.abs(z) < 10)) {
				// вырезаем дырку под тамбур
				height = -20;
			}
		}

		const obj = { rock: heightRock, ground: height };
		
		return obj;
	}
	///////////////////////////////////////////////////////////////////////////////////
	createTerrainGraphSquare(cellX: number, cellZ: number) {  // здесь roadX - смещение квадрата от дороги
		// генерируем графический квадрат со стороной this.TERRAIN_GRAPH_SQUARE_SIZE и центром cellX, cellZ (координаты клеточные; 0, 0 - в середине клетки)
		
		// разрешение графики зависит только от расстояния до дороги, по оси X
		// - но сейчас оно одинаковое, так не нужно стыковать
		let resolutionStep;
		
		if (!this.isPlayerPlace) {
			resolutionStep = this.TERRAIN_GRAPH_RESOLUTION; 
		} else {
			resolutionStep = this.TERRAIN_GRAPH_RESOLUTION_PLAYER_PLACE;
		}
		
		
		/*
		switch (Math.abs(cellX)) {
			case 0:
				resolutionStep = this.TERRAIN_GRAPH_RESOLUTION_0;
				break;
			case 1:
				resolutionStep = this.TERRAIN_GRAPH_RESOLUTION_1;
				break;
			default:
				resolutionStep = this.TERRAIN_GRAPH_RESOLUTION_2;
		}
		*/
		
		const object = new THREE.Object3D();
		
		// первый проход - расчёт высот в узлах карты; считаем на 1 узел дальше по каждой оси, поэтому <=, а не < 
		
		// строю 2 карты высот - для земли и для гор
		// - и сразу, на этом же проходе строю дорогу

		const pointsRoad: THREE.Vector3[] = [];
		const uvsRoad = [];
		
		
		const heightmap: any[] = [];  // двумерный массив объектов со свойствами ground, heightRock и т.д.

		
		const numVertices = this.TERRAIN_GRAPH_SQUARE_SIZE / resolutionStep;  // для текстур
		
//		console.log("numVertices = " + numVertices);
		
		const TERRAIN_GRAPH_SQUARE_SIZE_HALF = this.TERRAIN_GRAPH_SQUARE_SIZE / 2;


		let lawn: THREE.InstancedMesh = null!;
//		const maxGrassCount = 100;  // максимальное количество кустов травы на графический квадрат 
///		const maxGrassCount = 40;  // максимальное количество кустов травы на графический квадрат 
		const maxGrassCount = 20;  // максимальное количество кустов травы на графический квадрат 
		if (this.grass != null) {
			
			// генерируем траву в случайных местах
			const prng = alea(this.mapSeed + cellX + ":" + cellZ);  // чтобы random травы был детерминированным
		
			const grassObjs = [];
			
			// два прохода - на первом создаём массив 'координатных' объектов, на втором создаём только необходимые кусты
			for (let i = 0; i < maxGrassCount; i++) {
			
				const x = cellX * this.TERRAIN_GRAPH_SQUARE_SIZE + Math.floor(this.TERRAIN_GRAPH_SQUARE_SIZE * prng()) - TERRAIN_GRAPH_SQUARE_SIZE_HALF;
				const z = cellZ * this.TERRAIN_GRAPH_SQUARE_SIZE + Math.floor(this.TERRAIN_GRAPH_SQUARE_SIZE * prng()) - TERRAIN_GRAPH_SQUARE_SIZE_HALF;
			
				const road = this.getRoad(z);
				
				if ((x < road.roadLeft) || (x > road.roadRight)) {  // можно доработать, чтобы на удалении от дороги кустов было поменьше 
					const obj = this.getTerrainPoint(x, z);
					if (obj.ground > obj.rock) {  // кусты растим только на земле, на скалах не будем
					
						const scale = 1 + 2 * prng();
						const rotation = 2 * Math.PI * prng();
					
///						const grassObj = {x: x, y: obj.ground - 0.5, z: z, rotation: rotation, scale: scale};
						const grassObj = {x: x, y: obj.ground - 0.75, z: z, rotation: rotation, scale: scale};
						grassObjs.push(grassObj);
					
					}
				}
				
			}
			
			if (grassObjs.length > 0) { // чтобы при отсутствии травы на уровне не создавалась и лужайка
				lawn = this.grass.createLawn(grassObjs.length, this.grass.getSettings());
				object.add(lawn);

				for (let i = 0; i < grassObjs.length; i++) {
					this.grass.addGrassInstance(lawn, i, grassObjs[i].x, grassObjs[i].y, grassObjs[i].z, grassObjs[i].rotation, grassObjs[i].scale);
				}
			}
			
			
		}
		
		
		let i = 0;
		
		for (let iC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC <= TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC += resolutionStep) {
			
			const z = cellZ * this.TERRAIN_GRAPH_SQUARE_SIZE + iC;  // метры
			
			const road = this.getRoad(z);
			
			heightmap.push([]);

			for (let jC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC <= TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC += resolutionStep) {

				const x = cellX * this.TERRAIN_GRAPH_SQUARE_SIZE + jC;  // метры

				const nodeObj = this.getTerrainPoint(x, z);
				heightmap[i].push(nodeObj);
			}
			
			// дорогу считаем сразу, на первом проходе
			if (iC < TERRAIN_GRAPH_SQUARE_SIZE_HALF) {  // последний элемент для дороги не нужен

				const roadFar = this.getRoad(z + resolutionStep);
			
//				const shiftRoadBank = 0.02;  // приподнимаем над местностью основание насыпи
				const shiftRoadBank = 0;
				const shiftRoad = shiftRoadBank + this.ROAD_BANK_HEIGHT;  // приподнимаем дорогу на высоту насыпи

				const fullWidth = 2 * (this.ROAD_HALF_WIDTH + this.ROAD_BANK_WIDTH); 

				// создаём два левых треугольника насыпи, добавляем в геометрию
				let vLeftClose = new THREE.Vector3(road.roadLeft - this.ROAD_BANK_WIDTH, road.heightM + shiftRoadBank, z);
				let vLeftFar = new THREE.Vector3(roadFar.roadLeft - this.ROAD_BANK_WIDTH, roadFar.heightM + shiftRoadBank, z + resolutionStep);
			
				let vRightClose = new THREE.Vector3(road.roadLeft, road.heightM + shiftRoad, z);
				let vRightFar = new THREE.Vector3(roadFar.roadLeft, roadFar.heightM + shiftRoad, z + resolutionStep);

				pointsRoad.push(vLeftClose);
				pointsRoad.push(vLeftFar);
				pointsRoad.push(vRightFar);
			
				pointsRoad.push(vRightFar);
				pointsRoad.push(vRightClose);
				pointsRoad.push(vLeftClose);

				const u0 = 0;
				const u1 = this.ROAD_BANK_WIDTH / fullWidth;
				const u2 = (fullWidth - this.ROAD_BANK_WIDTH) / fullWidth;
				const u3 = 1;

				const v0 = 0;
				const v1 = 1;

				uvsRoad.push(u0, v0, 
							u0, v1, 
							u1, v1);
			
				uvsRoad.push(u1, v1, 
							u1, v0, 
							u0, v0);
			
			
				// создаём два треугольника дороги, добавляем в геометрию
				vLeftClose = new THREE.Vector3(road.roadLeft, road.heightM + shiftRoad, z);
				vLeftFar = new THREE.Vector3(roadFar.roadLeft, roadFar.heightM + shiftRoad, z + resolutionStep);
			
				vRightClose = new THREE.Vector3(road.roadRight, road.heightM + shiftRoad, z);
				vRightFar = new THREE.Vector3(roadFar.roadRight, roadFar.heightM + shiftRoad, z + resolutionStep);
			
				pointsRoad.push(vLeftClose);
				pointsRoad.push(vLeftFar);
				pointsRoad.push(vRightFar);
			
				pointsRoad.push(vRightFar);
				pointsRoad.push(vRightClose);
				pointsRoad.push(vLeftClose);

				uvsRoad.push(u1, v0, 
							u2, v0, 
							u2, v1);
			
				uvsRoad.push(u2, v1, 
							u1, v1, 
							u1, v0);

				// создаём два правых треугольника насыпи, добавляем в геометрию
				vLeftClose = new THREE.Vector3(road.roadRight, road.heightM + shiftRoad, z);
				vLeftFar = new THREE.Vector3(roadFar.roadRight, roadFar.heightM + shiftRoad, z + resolutionStep);
			
				vRightClose = new THREE.Vector3(road.roadRight + this.ROAD_BANK_WIDTH, road.heightM + shiftRoadBank, z);
				vRightFar = new THREE.Vector3(roadFar.roadRight + this.ROAD_BANK_WIDTH, roadFar.heightM + shiftRoadBank, z + resolutionStep);
			
				pointsRoad.push(vLeftClose);
				pointsRoad.push(vLeftFar);
				pointsRoad.push(vRightFar);
			
				pointsRoad.push(vRightFar);
				pointsRoad.push(vRightClose);
				pointsRoad.push(vLeftClose);

				uvsRoad.push(u2, v0, 
							u2, v1, 
							u3, v1);
			
				uvsRoad.push(u3, v1, 
							u3, v0, 
							u2, v0);
							
			}
			
			i++;
		}
		
		const pointsGround: THREE.Vector3[] = [];
		const uvsGround = [];
		
		const pointsRock: THREE.Vector3[] = [];
		const uvsRock = [];
		
		i = 0;
		
		// второй проход - на основе массива высот строим сетки
		for (let iC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC < TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC += resolutionStep) {
			
			const z = cellZ * this.TERRAIN_GRAPH_SQUARE_SIZE + iC;  // метры
			
			let j = 0;
			
			for (let jC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC < TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC += resolutionStep) {
			
				const x = cellX * this.TERRAIN_GRAPH_SQUARE_SIZE + jC /*- 0*roadX*/;  // метры

				// создаём меш ground
				let vLeftClose = new THREE.Vector3(x, heightmap[i][j].ground, z);
				let vLeftFar = new THREE.Vector3(x, heightmap[i + 1][j].ground, z + resolutionStep);
			
				let vRightClose = new THREE.Vector3(x + resolutionStep, heightmap[i][j + 1].ground + 0 * (i % 2), z);
				let vRightFar = new THREE.Vector3(x + resolutionStep, heightmap[i + 1][j + 1].ground + 0 * (i % 2), z + resolutionStep);
				
				
				
				
				
				
				pointsGround.push(vLeftClose);
				pointsGround.push(vLeftFar);
				pointsGround.push(vRightFar);
				
				pointsGround.push(vRightFar);
				pointsGround.push(vRightClose);
				pointsGround.push(vLeftClose);
				
				let u0 = j / numVertices;
				let u1 = (j + 1)  / numVertices;
				let v0 = i / numVertices;
				let v1 = (i + 1) / numVertices;
	
				uvsGround.push(u0, v0, 
							u0, v1, 
							u1, v1);
			
				uvsGround.push(u1, v1, 
							u1, v0, 
							u0, v0);

				// создаём меш rock
				vLeftClose = new THREE.Vector3(x, heightmap[i][j].rock, z);
				vLeftFar = new THREE.Vector3(x, heightmap[i + 1][j].rock, z + resolutionStep);
			
				vRightClose = new THREE.Vector3(x + resolutionStep, heightmap[i][j + 1].rock, z);
				vRightFar = new THREE.Vector3(x + resolutionStep, heightmap[i + 1][j + 1].rock, z + resolutionStep);

				// заплатка для формирования дыр в горах				
				if ((vLeftClose.y > -1000) && (vLeftFar.y > -1000) && (vRightFar.y > -1000) && (vRightFar.y > -1000)) {
					pointsRock.push(vLeftClose);
					pointsRock.push(vLeftFar);
					pointsRock.push(vRightFar);
				
					pointsRock.push(vRightFar);
					pointsRock.push(vRightClose);
					pointsRock.push(vLeftClose);
				
					u0 = j / numVertices;
					u1 = (j + 1)  / numVertices;
					v0 = i / numVertices;
					v1 = (i + 1) / numVertices;
				
					uvsRock.push(u0, v0, 
								u0, v1, 
								u1, v1);
			
					uvsRock.push(u1, v1, 
								u1, v0, 
								u0, v0);
					
				}
							
				j++;			
				
			}
			
			i++;
		}

		// ground
		let geometry: THREE.BufferGeometry = new THREE.BufferGeometry();   
		geometry.setFromPoints(pointsGround);
		geometry.computeBoundingSphere();
		geometry.computeVertexNormals();
		
		const nUvComponents = 2;
		geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvsGround), nUvComponents));

		const meshGround: THREE.Mesh = new THREE.Mesh(geometry, this.materialGround);
		meshGround.receiveShadow = true;
		meshGround.castShadow = true;  // машина может попасть в тень соседнего холма, так что пусть будет (на высоких настройках)
		object.add(meshGround);

		// rock
		geometry = new THREE.BufferGeometry();   
		geometry.setFromPoints(pointsRock);
		geometry.computeBoundingSphere();
		geometry.computeVertexNormals();
		
		geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvsRock), nUvComponents));


		const meshRock: THREE.Mesh = new THREE.Mesh(geometry, this.materialRock);
		meshRock.receiveShadow = true;
		meshRock.castShadow = true;
		object.add(meshRock);

		// дорога
		if (this.gameMode != 'trophy') {
			geometry = new THREE.BufferGeometry();   
			geometry.setFromPoints(pointsRoad);
			geometry.computeBoundingSphere();
			geometry.computeVertexNormals();
		
			geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvsRoad), nUvComponents));

			const meshRoad: THREE.Mesh = new THREE.Mesh(geometry, this.materialRoad);
//			const wireframeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: true });
//			const meshRoad: THREE.Mesh = new THREE.Mesh(geometry, wireframeMaterial);
			meshRoad.receiveShadow = true;
			object.add(meshRoad);
		
		}
		
		return object;
	}
	///////////////////////////////////////////////////////////////////////////////////
	getCamera() {
		return this.camera;
	}
	///////////////////////////////////////////////////////////////////////////////////
	switchAutoSteering(autoSteeringChecked: boolean) {
		if (this.car != null) {
			this.car.switchAutoSteering(autoSteeringChecked);
		}
	}
	///////////////////////////////////////////////////////////////////////////////////
	computeFaceNormals(vertices: CANNON.Vec3[], faces: number[][]) {
		
		const centroid = new CANNON.Vec3();
		
		this.calculateCentroid(centroid, vertices);

		return faces.map((faceVertexIndices: number[]) => {
			
			const tmp_vec_1 = new CANNON.Vec3();
			const tmp_vec_2 = new CANNON.Vec3();			
			
			const A = vertices[faceVertexIndices[0]];
			const A_to_B = tmp_vec_1.copy(vertices[faceVertexIndices[1]]);
			const A_to_C = tmp_vec_2.copy(vertices[faceVertexIndices[2]]);
			A_to_B.vsub(A, A_to_B);
			A_to_C.vsub(A, A_to_C);

			const faceNormal = new CANNON.Vec3().copy(A_to_B);
			faceNormal.cross(A_to_C, faceNormal).normalize();

			const centroid_to_A = tmp_vec_1.copy(A);
			A.vsub(centroid, centroid_to_A);

			if (faceNormal.dot(centroid_to_A) < 0) {
				faceNormal.negate();
			}

			return faceNormal;
		});
	}
	///////////////////////////////////////////////////////////////////////////////////
	calculateCentroid(centroid: CANNON.Vec3, vertices: CANNON.Vec3[]) {
		const { length: vertexCount } = vertices;

		centroid.set(0, 0, 0);

		for (let i = 0; i < vertexCount; i++) {
			centroid.vadd(vertices[i], centroid);
		}

		centroid.scale(1 / vertexCount, centroid);
	}	
	///////////////////////////////////////////////////////////////////////////////////

}
export default GameSceneRace;
